import React from 'react';
import { colors } from '../constants';

const ReminderIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
  >
    <path
      fill={props.color}
      d="M16.104 10.193c0-3.326-2.73-6.026-6.104-6.026s-6.104 2.7-6.104 6.026c0 3.326 2.73 6.025 6.104 6.025 3.373 0 6.104-2.7 6.104-6.025zm1.063-2.52c.283.787.437 1.636.437 2.52 0 2.348-1.087 4.445-2.79 5.824l1.053 1.04c.295.292.298.767.007 1.06-.292.296-.766.298-1.06.007l-1.195-1.18c-.03-.028-.056-.06-.08-.09-1.057.552-2.262.864-3.54.864-1.182 0-2.3-.267-3.298-.743l-.013.014-1.194 1.177c-.294.292-.77.29-1.06-.006-.292-.293-.29-.768.006-1.06l.94-.928c-1.815-1.375-2.986-3.54-2.986-5.98 0-.805.128-1.582.365-2.31-.108-.034-.21-.094-.297-.18-1.423-1.408-1.423-3.582 0-4.99 1.42-1.402 3.605-1.402 5.023 0 .09.09.155.2.19.313.732-.232 1.513-.358 2.324-.358.843 0 1.654.136 2.412.387.03-.14.098-.27.207-.378 1.368-1.354 3.477-1.354 4.846 0 1.374 1.358 1.374 3.457 0 4.815-.087.087-.19.148-.3.182zm-.65-1.36c.672-.767.637-1.836-.106-2.57-.752-.746-1.86-.775-2.642-.088 1.13.64 2.078 1.556 2.75 2.658zM3.38 6.487c.683-1.192 1.684-2.18 2.89-2.853-.827-.676-1.97-.628-2.752.145-.78.77-.826 1.893-.138 2.707zm3.766 3.48c-.414 0-.75.336-.75.75s.336.75.75.75h2.886c.414 0 .75-.336.75-.75v-4.28c0-.413-.336-.75-.75-.75s-.75.337-.75.75v3.53H7.146z"
    />
  </svg>
);

ReminderIcon.defaultProps = {
  color: colors.mediumGrey,
};

export default ReminderIcon;
